import React, {
  useEffect,
  useState,
  useCallback,
  lazy,
  Suspense,
  startTransition,
} from "react";
import "./admin.css";
import perfilIcon from "../../../assets/imgs/dashboard-admin/logo-horus.png";
import conexiones_i from "../../../assets/imgs/navbar/conexiones.svg";
import camara_i from "../../../assets/imgs/navbar/icon.svg";
import gestion_i from "../../../assets/imgs/navbar/gestion.svg";
import domestico_i from "../../../assets/imgs/navbar/domestico.svg";
import { Tooltip } from "react-tooltip";
import {
  FaTimes,
  FaSignOutAlt,
  FaBars,
  FaPlaneDeparture,
  FaPlaneArrival,
} from "react-icons/fa";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import Swal from "sweetalert2";
import Loading from "../components/loading/loading";
import SessionExpired from "../../../components/session-expired/session-expired";
import MainBanner from "../../../components/dashboard/main-banner/main-banner";
import { useNavigate } from "react-router-dom";
import Entries from "./export/entries/entries";

import { gestionDeAlmacenMenu as menuExportacion } from "./menu_redisenio/exportacion";
import { gestionDeAlmacenMenu as menuImportacion } from "./menu_redisenio/importacion";
import { gestionDeAlmacenMenu as menuConexiones } from "./menu_redisenio/conexiones";
import { gestionDeAlmacenMenu as menuGestiones } from "./menu_redisenio/gestion";
import { gestionDeAlmacenMenu as menuCamara } from "./menu_redisenio/camara";
import { redirectComponent } from "../../../services/redirect-components";
import ExchangeRate from "./others/exchangeRate/exchangeRate";
import ImpoTariff from "./others/impo_tariff/impoTariff";
import ExpoTariff from "./others/expo_tariff/expoTariff";
import AltasTransitos from "./altas_transitos/altasTransitos";

// Componentes lazy loaded
const Bienvenido = lazy(() => import("./bienvenido/bienvenido"));
const MenuImportacion = lazy(() => import("./menu_redisenio/importacion"));
const MenuExportacion = lazy(() => import("./menu_redisenio/exportacion"));
const MenuConexiones = lazy(() => import("./menu_redisenio/conexiones"));
const MenuGestion = lazy(() => import("./menu_redisenio/gestion"));
const MenuCamaraFria = lazy(() => import("./menu_redisenio/camara"));
const MenuDomestico = lazy(() => import("./menu_redisenio/domestico"));

// Mapa de componentes
const componentMap = {
  // Menús principales
  MenuImportacion,
  MenuExportacion,
  MenuConexiones,
  MenuGestion,
  MenuCamaraFria,
  MenuDomestico,

  // Resto de componentes
  Usuarios: lazy(() => import("./usuarios/usuarios")),
  Permisos: lazy(() => import("./permisos/permisos")),
  Tarimas: lazy(() => import("./tarimas/tarimas")),
  RemitentesConsignatarios: lazy(
    () => import("./remitentes-consignatarios/remitentes-consignatarios"),
  ),
  LiftTrucks: lazy(() => import("./lift-trucks/lift-trucks")),
  CoolerUsers: lazy(() => import("./cooler_users/cooler_users")),
  Warehouses: lazy(() => import("./iwarehouses/iwarehouses")),
  PaymentConditions: lazy(
    () => import("./payment-conditions/payment-conditions"),
  ),
  PaymentTypes: lazy(() => import("./payment-types/payment-types")),
  Agents: lazy(() => import("./agents/agents")),
  Institutions: lazy(() => import("./institutions/institutions")),
  ClientsExpo: lazy(() => import("./clients-expo/clients_expo")),
  Irregularity: lazy(() => import("./irregularity_types/irregularity_types")),
  CFDITypes: lazy(() => import("./cfdi-types/cfdi-types")),
  Clients: lazy(() => import("./clients/clients")),
  Users: lazy(() => import("./users/users")),
  PasswordExp: lazy(() => import("./password-exp/passwordExp")),
  PerfilesUsuario: lazy(() => import("./users_profile/users_profile")),
  Capture: lazy(() => import("./export/capture/capture")),
  Assignment: lazy(() => import("./export/assignment/assignment")),
  Exp_Irregularities_sat: lazy(
    () => import("./export/irregularities_sat/irregularities_sat"),
  ),
  UPD: lazy(() => import("./export/upd-m-h/upd")),
  Entries: lazy(() => import("./export/entries/entries")),
  Billing: lazy(() => import("./export/invoice")),
  Auditor: lazy(() => import("./export/auditor/auditor")),
  ACAS: lazy(() => import("./export/acas/acas-main")),
  Acceptance: lazy(() => import("./export/acceptance/acceptance")),
  Departures: lazy(() => import("./export/departures/departures")),
  Withdrawals: lazy(() => import("./export/withdrawals/withdrawals")),
  Lags: lazy(() => import("./export/lags/lags")),
  Incidents: lazy(() => import("./incidents/incidents")),
  Milestones: lazy(() => import("./milestones/milestones")),
  AddExtras: lazy(() => import("./add-extras/add-extras")),
  KardexTransits: lazy(() => import("./kardex-transits/kardex-transits")),
  CheckInFlights: lazy(() => import("./checkIn-flights/checkin-flights")),
  FactAdmin: lazy(() => import("./export/fact_admin/fact_admin_main")),
  KardexExpo: lazy(() => import("./others/kardex_expo/kardex_expo")),
  Quoter: lazy(() => import("./others/quoter/quoter")),
  Exceptions: lazy(() => import("./others/exceptions/exceptions")),
  BatchBilling: lazy(() => import("./others/batch_billing/batch_billing")),
  BatchCancellation: lazy(
    () => import("./others/batch_cancellation/batch_cancellation"),
  ),
  TradingRules: lazy(() => import("./others/trading-rules/trading-rules")),
  ULDS: lazy(() => import("./ulds/ulds")),
  ReportTransit: lazy(() => import("./repor_transit/report_transit")),
  PinLift: lazy(() => import("./pin-lift/pin-lift")),
  Quote: lazy(() => import("./export/quote/quote")),
  FlightRecords: lazy(
    () => import("./import/entries/flight-records/flight-records"),
  ),
  Arrivals: lazy(() => import("./import/entries/arrivals/arrivals")),
  ExternalDesWarehouses: lazy(
    () => import("./external_des_warehouses/external_des_warehouses"),
  ),
  ValeCooler: lazy(() => import("./cooler/vale-cooler/valeCooler")),
  DashboardCooler: lazy(
    () => import("./cooler/dashboard-cooler/dashboard-cooler"),
  ),
  TradeRules: lazy(() => import("./export/trade_rules/trade_rules")),
  BatchFat: lazy(() => import("./export/batch_fat/batch_fat")),
  Previous: lazy(() => import("./import/previous")),
  AltaDesco: lazy(() => import("./import/billingSupervision/altaDesco")),
  Manifiesto: lazy(() => import("./import/entries/manifiesto/manifiesto")),
  Master: lazy(() => import("./import/entries/master/master")),
  ExchangeRate: lazy(() => import("./others/exchangeRate/exchangeRate")),
  ImpoTariff: lazy(() => import("./others/impo_tariff/impoTariff")),
  Inventario: lazy(() => import("./import/entries/inventario/inventario")),
  ExpoTariff: lazy(() => import("./others/expo_tariff/expoTariff")),
  Upd: lazy(() => import("./import/incidents/upd/upd")),
  AltasTransitos: lazy(() => import("./altas_transitos/altasTransitos")),
  IrregularidadesSat: lazy(
    () => import("./import/incidents/irregularidadesSat/irregularidadesSat"),
  ),
};

function Admin() {
  const topIcons = [
    {
      key: "importacion",
      icon: <FaPlaneArrival className="fs-5 text-white" />,
      tooltip: "Importación",
    },
    {
      key: "conexiones",
      icon: <img src={conexiones_i} alt="" />,
      tooltip: "Conexiones",
    },
    {
      key: "camara_fria",
      icon: <img src={camara_i} alt="" />,
      tooltip: "Cámara Fría",
    },
    {
      key: "exportacion",
      icon: <FaPlaneDeparture className="fs-5 text-white" />,
      tooltip: "Exportación",
    },
    {
      key: "gestion_de_almacen",
      icon: <img src={gestion_i} alt="" />,
      tooltip: "Gestión de Almacén",
    },
    {
      key: "domestico",
      icon: <img src={domestico_i} alt="" />,
      tooltip: "Doméstico",
    },
  ];

  const { user, isAuthenticated, isLoading, logout, loginWithRedirect } =
    useAuth0();
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState("");
  const [click, setClick] = useState(false);
  const [activePath, setActivePath] = useState("");
  const [permissions, setPermissions] = useState([]);
  const navigate = useNavigate();
  const [activeIcon, setActiveIcon] = useState(null);
  const [gestionOpenSignal, setGestionOpenSignal] = useState(0);
  const [cubiscanStatus, setCubiscanStatus] = useState(0);

  useEffect(() => {
    const path = window.location.search;
    sessionStorage.setItem("currentUrl", path);
  }, []);

  // useEffect(() => {
  //   if (isLoading) return;

  //   const token = sessionStorage.getItem("token");

  //   // 🔐 Sin sesión Auth0 → ir a login federado
  //   if (!isAuthenticated) {
  //     loginWithRedirect();
  //     return;
  //   }

  //   // 🔐 Hay sesión Auth0 pero no token backend → volver a logear en tu API
  //   if (isAuthenticated && !token) {
  //     loginWithRedirect();
  //   }
  // }, [isLoading, isAuthenticated, loginWithRedirect]);

  const fetchCubiscanStatus = useCallback(async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_status_cubiscan`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        },
      );
      res.data?.code === 1 && setCubiscanStatus(res.data.data.status);
    } catch (error) {
      console.error("Error fetching Cubiscan status:", error);
    }
  }, []);

  useEffect(() => {
    if (activeIcon === "gestion_de_almacen") {
      setGestionOpenSignal((s) => s + 1);
      fetchCubiscanStatus();
    }
  }, [activeIcon, fetchCubiscanStatus]);

  // useEffect(() => {
  //   const loginWithRetries = async (data, retries = 5) => {
  //     for (let attempt = 1; attempt <= retries; attempt++) {
  //       try {
  //         const response = await axios.post(
  //           `${process.env.REACT_APP_URL_BACKEND}/api/v1/users/login`,
  //           data,
  //         );

  //         if (response.data.code === 1) {
  //           //           Swal.fire({
  //           //             title: "Usuario logeado exitosamente",
  //           //             icon: "success",
  //           //           });

  //           const userData = {
  //             id: response.data.user.id,
  //             first_name: response.data.user.first_name,
  //             last_name: response.data.user.last_name,
  //             email: response.data.user.email,
  //             role_id: response.data.user.role_id,
  //           };

  //           localStorage.setItem("user", JSON.stringify(userData));
  //           sessionStorage.setItem("token", response.data.user.token);
  //           sessionStorage.setItem(
  //             "tokenExpire",
  //             response.data.user.tokenExpiration,
  //           );
  //           localStorage.setItem("username", user.nickname);
  //           localStorage.setItem("photo", user.picture);

  //           // const permissionsRes = await axios.get(
  //           //   `${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/${response.data.user.id}`,
  //           //   {
  //           //     headers: {
  //           //       Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  //           //     },
  //           //   },
  //           // );

  //           // localStorage.setItem(
  //           //   "permissions",
  //           //   JSON.stringify(permissionsRes.data.data),
  //           // );
  //           // setPermissions(permissionsRes.data.data);
  //           setHasFetchedData(true);
  //           break;
  //         }
  //       } catch (error) {
  //         console.error("error: ", error);
  //         attempt === retries && setHasFetchedData(true);
  //       }
  //     }
  //   };

  //   if (user && isAuthenticated && !hasFetchedData) {
  //     const data = { email: user.email, key: process.env.REACT_APP_KEY };
  //     loginWithRetries(data);
  //   }
  // }, [isAuthenticated, hasFetchedData, user]);

  const logoutAdmin = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("tokenExpire");
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");

    logout({
      logoutParams: {
        returnTo: process.env.REACT_APP_LOGOUT_URL,
      },
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const module = params.get("module");
    const view = params.get("view");

    sessionStorage.setItem("currentModule", view !== "#" ? view : "");
    setActiveIcon(module);

    const menuArr = setMenuArr(module);

    if (!menuArr) return;

    const activePath = setViewAndUrl(view, menuArr);
    console.info(activePath.split("/")[1]);
    sessionStorage.setItem("sub-module", activePath.split("/")[1]);

    handleComponentChange(view, activePath);
  }, []);

  const setMenuArr = (module) => {
    switch (module) {
      case "importacion":
        return menuImportacion;
      case "exportacion":
        return menuExportacion;
      case "conexiones":
        return menuConexiones;
      case "gestion_de_almacen":
        return menuGestiones;
      case "camara_fria":
        return menuCamara;
      case "domestico":
        return menuCamara;
      default:
        return [];
    }
  };

  const setViewAndUrl = (view, menu) => {
    for (const item of menu) {
      if (item.enlace === view) {
        return item.activo;
      }

      if (item.hijos && item.hijos.length > 0) {
        const encontradoEnHijos = setViewAndUrl(view, item.hijos);

        if (encontradoEnHijos) {
          return encontradoEnHijos;
        }
      }
    }
    return "";
  };

  const sectionNames = {
    Usuarios: "Usuarios",
    Permisos: "Permisos",
    Tarimas: "Tarimas",
    CoolerUsers: "Usuarios Cooler",
    ExternalDesWarehouses: "Almacenes externos destino",
    Agents: "Agentes",
    PerfilesUsuario: "Perfil de Usuarios",
    RemitentesConsignatarios: "Remitentes/Consignatarios",
    LiftTrucks: "Montacarguistas",
    PaymentConditions: "Condiciones de pago",
    PaymentTypes: "Tipos de pago",
    Irregularity: "Irregularidades",
    CFDITypes: "Tipos de CFDI",
    Institutions: "Instituciones",
    Clients: "Clientes",
    ClientsExpo: "Clientes Expo",
    Users: "Usuarios",
    PasswordExp: "Exp. Contraseñas",
    Incidents: "Incidencias",
    Capture: "Captura",
    Assignment: "Asignación",
    Exp_Irregularities_sat: "Irregularidades SAT Expo",
    UPD: "UPD",
    Entries: "Entradas",
    Billing: "Pre-facturación",
    Auditor: "Auditor",
    FactAdmin: "Facturación Administrativa",
    ACAS: "ACAS",
    Acceptance: "Aceptación",
    Departures: "Salidas",
    Withdrawals: "Desistimientos",
    Lags: "Rezagos",
    KardexExpo: "Kárdex Exportación",
    Quoter: "Cotizador",
    Exceptions: "Excepciones",
    BatchBilling: "Batch de facturas no timbradas",
    BatchCancellation:
      "Batch de facturas canceladas en espera de UUID referenciado",
    TradingRules: "Reglas Comerciales",
    Milestones: "Milestones",
    AddExtras: "Altas Tránsitos",
    KardexTransits: "Kárdex Tránsitos",
    CheckInFlights: "Check In",
    Report_transit: "Tránsitos",
    ULDS: "ULD's",
    ValeCooler: "Cooler",
    DashboardCooler: "Dashboard Cooler",
    FlightRecords: "Registro Vuelo",
    Arrivals: "Arribos",
    Warehouses: "Almacenes",
    Quote: "Cotización",
    TradeRules: "Reglas Comerciales",
    BatchFat: "Batch FAT",
    Previous: "Almacén",
    AltaDesco: "Alta desco",
    ExchangeRate: "Tipo de Cambio",
    ImpoTariff: "Tarifario IMPO",
    AltasTransitos: "Altas Tránsitos",
  };

  const changeLaravelView = (view) => {
    let componentName = "";
    const parentView = view.split("/")[1];
    const viewChild = view.split("/")[2];
    const parentViewChild = view.split("/")[3];

    switch (view.split("/")[0]) {
      case "importación":
        componentName = "Importacion";
        break;
      case "conexiones":
        componentName = "Conexiones";
        break;
      case "cámara_fría":
        componentName = "Camara_fria";
        break;
      case "exportación":
        componentName = "Exportacion";
        break;
      case "gestión_de_almacén":
        componentName = "Almacen";
        break;
      case "doméstico":
        componentName = "Domestico";
        break;
      default:
        componentName = "";
        break;
    }

    if (!parentView && !viewChild) {
      return;
    }

    if (!redirectComponent[componentName]) return;
    if (!redirectComponent[componentName][parentView]) return;

    if (!view.split("/")[2]) {
      console.info(
        "url-redirect-child: ",
        redirectComponent[componentName][parentView].activo,
      );

      window.location.href = `${process.env.REACT_APP_URL_TO_LARAVEL}?destino=${redirectComponent[componentName][parentView].activo}`;
      return;
    }

    if (!redirectComponent[componentName][parentView][viewChild]) return;

    if (!view.split("/")[3]) {
      console.info(
        "url-redirect-child2: ",
        redirectComponent[componentName][parentView][viewChild].activo,
      );

      window.location.href = `${process.env.REACT_APP_URL_TO_LARAVEL}?destino=${redirectComponent[componentName][parentView][viewChild].activo}`;
      return;
    }

    if (
      !redirectComponent[componentName][parentView][viewChild][parentViewChild]
    )
      return;

    console.info(
      "url-redirect: ",
      redirectComponent[componentName][parentView][viewChild][parentViewChild]
        .activo,
    );

    window.location.href = `${process.env.REACT_APP_URL_TO_LARAVEL}?destino=${redirectComponent[componentName][parentView][viewChild][parentViewChild].activo}`;
  };

  const handleComponentChange = (componentName, newActivePath) => {
    if (componentName === "#") {
      changeLaravelView(newActivePath);
    }

    startTransition(() => {
      setSelectedComponent(componentName);
      setActivePath(normalizePathForDisplay(newActivePath));
    });
  };

  const handleIconClick = (iconKey) => {
    startTransition(() => {
      setActiveIcon(activeIcon === iconKey ? null : iconKey);
    });
  };

  const normalizePathForDisplay = (pathString) => {
    if (!pathString) return "";
    const lowerWords = ["de", "la", "el", "y", "a"];

    return pathString
      .replace(/_/g, " ")
      .split("/")
      .map((segment) =>
        segment
          .split(" ")
          .map((word, idx) =>
            lowerWords.includes(word.toLowerCase()) && idx > 0
              ? word.toLowerCase()
              : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
          )
          .join(" "),
      )
      .join(" / ");
  };

  const RenderPathSegments = ({ pathString }) => {
    if (!pathString) return null;

    const segments = pathString.split(" / ");

    return (
      <div className="path-segment-container d-flex align-items-center">
        {segments.map((segment, index) => (
          <React.Fragment key={index}>
            <span
              className={
                index === segments.length - 1
                  ? "path-last-segment"
                  : "path-segment-item"
              }
            >
              {segment}
            </span>
            {index < segments.length - 1 && (
              <span className="path-separator mx-1">/</span>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const ContentLoader = () => (
    <div
      className="content-loader d-flex align-items-center justify-content-center"
      style={{ minHeight: "400px" }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Cargando...</span>
      </div>
    </div>
  );

  // if (isLoading || !hasFetchedData) return <Loading />;
  // if (!isAuthenticated) return null;

  const welcomeText = !activeIcon
    ? `¡Bienvenido a Horus, ${localStorage.getItem("username")}!`
    : activeIcon === "importacion"
      ? "Importación"
      : activeIcon === "exportacion"
        ? "Exportación"
        : activeIcon === "gestion_de_almacen"
          ? "Gestión de Almacén"
          : activeIcon === "conexiones"
            ? "Conexiones"
            : activeIcon === "camara_fria"
              ? "Cámara Fría"
              : activeIcon === "domestico"
                ? "Doméstico"
                : "Otros";

  const renderMenuComponent = () => {
    switch (activeIcon) {
      case "importacion":
        return <MenuImportacion onComponentChange={handleComponentChange} />;
      case "exportacion":
        return <MenuExportacion onComponentChange={handleComponentChange} />;
      case "conexiones":
        return <MenuConexiones onComponentChange={handleComponentChange} />;
      case "gestion_de_almacen":
        return (
          <MenuGestion
            onComponentChange={handleComponentChange}
            openSignal={gestionOpenSignal}
            openParam={cubiscanStatus}
            onCubiscanRequest={() => {
              setGestionOpenSignal((s) => s + 1);
              fetchCubiscanStatus();
            }}
          />
        );
      case "camara_fria":
        return <MenuCamaraFria onComponentChange={handleComponentChange} />;
      case "domestico":
        return <MenuDomestico onComponentChange={handleComponentChange} />;
      default:
        return null;
    }
  };

  return (
    <div className="container-fluid p-0 m-0">
      <MainBanner />

      <div className="welcome-bar">
        <p>{welcomeText}</p>
      </div>

      <div className="d-flex">
        <div className="admin-menu">
          <div
            className="menu-icon-open-close"
            onClick={() => setClick(!click)}
          >
            {click ? <FaTimes size={28} /> : <FaBars size={28} />}
          </div>

          <div className={click ? "menu-admin active" : "menu-admin"}>
            <div className="d-flex flex-column">
              <div className="d-flex justify-content-center">
                <img className="admin-profile-img" src={perfilIcon} alt="" />
              </div>
              <div className="d-flex justify-content-center">
                <p>
                  <font size="1" className="text-white">
                    V. 1.0
                  </font>
                </p>
              </div>
            </div>

            <div className="d-flex">
              {topIcons.map((item) => (
                <div className="d-flex align-items-center mx-1" key={item.key}>
                  <div
                    className={`${topIcons.length < 6 ? "max-circle" : "min-circle"} icon-circle d-flex align-items-center justify-content-center mb-1 ${
                      activeIcon === item.key ? "active" : ""
                    }`}
                    onClick={() => handleIconClick(item.key)}
                    data-tooltip-id={`importacion-tip-${item.key}`}
                    data-tooltip-content={item.tooltip}
                    data-tooltip-place="Top"
                  >
                    {item.icon}
                  </div>
                  <Tooltip
                    id={`importacion-tip-${item.key}`}
                    className="dark-tooltip"
                  />
                </div>
              ))}
            </div>

            <div className="sidebar-scroll">{renderMenuComponent()}</div>

            <div className="logout-container">
              <button className="button-logout" onClick={logoutAdmin}>
                <div className="text-menu-item-logout text-center w-100">
                  <FaSignOutAlt className="fs-5" />
                  <p className="ps-2 m-0">
                    <b>Cerrar sesión</b>
                  </p>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="main-content flex-grow-1">
            {selectedComponent === "" ? (
              <div className="menu-item-content"></div>
            ) : (
              <div className="menu-item-content-vistas">
                <div className="row mb-3">
                  {activeIcon && selectedComponent && (
                    <div className="breadcrumb-bar px-3 py-2">
                      <small>
                        <RenderPathSegments pathString={activePath} />
                      </small>
                    </div>
                  )}
                </div>
                <div className="main-panel px-2 py-2">
                  <h4>{sectionNames[selectedComponent] || ""}</h4>
                  <div className="main-panel-body">
                    <Suspense fallback={<ContentLoader />}>
                      {(() => {
                        const Component = componentMap[selectedComponent];
                        return Component ? <Component /> : "";
                      })()}
                    </Suspense>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admin;
